import React from 'react'
import { GetMonthlyPrice } from './get-monthly-price'
import { CallTollFree } from './call-toll-free'
import { CarouselItem } from './carousel-item'
import { LeftContent } from './left-content'
import { RightContent } from './right-content'

export const PayrollHero = () => {
  return (
    <CarouselItem extraContent={<GetMonthlyPrice />}>
      <LeftContent
        description="Financial application suited for dairy business."
        title={
          <>
            Producer Payrolls
            <br />
            Milk Laboratory Integration
            <br />
            Milk Hauler and Manifesting
          </>
        }
      >
        <CallTollFree />
      </LeftContent>

      <RightContent url="payroll/payroll.png" alt="laptop payroll" />
    </CarouselItem>
  )
}
